
export default {
  name: 'ModalVideo',
  computed: {
    videoUrl() {
      return `${process.env.VUE_APP_BACKEND_API_URL}videos/video_page_entreprise.mp4`;
    },
  },
};
